import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'

import { Layout, Header } from 'app/theme/layout'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from '../occasions/shared/OccasionPageGrid'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import Calculator from 'app/theme/calculator'

import heroImg from 'assets/img/employee-appreciation-hero.jpg'
import gridImage1 from 'assets/img/employee-appreciation-1.jpeg'
import gridImage2 from 'assets/img/employee-appreciation-2.jpg'
import gridImage3 from 'assets/img/employee-appreciation-3.jpg'
import gridImage4 from 'assets/img/employee-appreciation-4.jpg'

export default function EmployeeAppreciationCateringPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Employee Appreciation Catering - Roaming Hunger</title>
        <meta name="og:title" content="Employee Appreciation Catering"></meta>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImg}
          title="Employee Appreciation Catering"
          onButtonClick={openModal}
          description={(
            <div>
              Thank Your Employees (Safely) for Their Hard Work
            </div>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}

      <div className="container text-center py-12 px-8">
        <h2 className="text-navy text-4xl leading-tight font-platform">
          Bring lunch straight to your office with our network of 18,000+ food trucks, carts,
          pop-ups, and other mobile food providers.
        </h2>
      </div>

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Safety First"
          content={
            <div>
              <p>
                Mobile food facilities are among the safest options for catering right now.
                Meals are served outdoors and prepared in a self-contained kitchen accessible
                to only a small staff. Roaming Hunger also takes these extra steps to ensure safety:"
              </p>
              <ul className="list-disc pl-6 my-6">
                <li>Requiring food truck staff to wear gloves and masks during service</li>
                <li>Sanitizing vehicles and prep stations throughout the day</li>
                <li>Limiting communal items and areas, condiment & drink stations, and seating</li>
                <li>Encouraging social distancing protocols</li>
                <li>Providing Order Ahead options</li>
              </ul>
              <p>
                For more information on our safety procedures,
                <a href="/food-truck-catering/roaming-hunger-guarantee/" target="_blank" className="text-blue"> click here</a>.</p>
            </div>
          }
          image={gridImage1}

        />
      </OccasionPageGrid>

      <WhyWorkWithUs
        onButtonClick={openModal}
      />

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Great Food & Great Variety"
          content="With a massive network of trucks at our disposal, we can optimize your office’s experience based on taste, preference, and occasion. Whether you want taco Tuesday once a week or an ice cream truck to celebrate the start of summer, we have you covered."
          image={gridImage2}
          reverse
        />
        <OccasionPageGridRow
          heading="Unmatched Experience"
          content="With over 90,000 placements each year, we are the mobile food experts. Whether you need a truck outside a grocery store to feed hardworking essential staff or are looking to provide lunch for 100+ employees in a multi story office building, we have the resources to handle it."
          image={gridImage3}
        />
        <OccasionPageGridRow
          heading="Support Local Business"
          content="All our mobile food providers are sourced from the local community. Not only will you be treating your employees, you’ll be supporting businesses across your area. This means creating jobs and stimulating the local economy."
          image={gridImage4}
          reverse
        />
      </OccasionPageGrid>

      <CuisineTypes baseUrl='/food-truck-catering' />

      <HowItWorks
        heading="How Employee Appreciation Catering Works"
        onButtonClick={openModal}
      />
      <HowItWorksLarge
        heading="How Employee Appreciation Catering Works"
        onButtonClick={openModal}
      />
    </Layout>
  )
}
